module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-autocomplete', {
    ref: "contactSearch",
    staticStyle: {
      "max-width": "200px",
      "margin-top": "25px"
    },
    attrs: {
      "rounded": "",
      "flat": "",
      "solo-inverted": "",
      "dense": "",
      "return-object": "",
      "hide-no-data": "",
      "full-width": "",
      "prepend-inner-icon": "search",
      "label": "Search...",
      "item-text": "fullName",
      "item-value": "objectID",
      "items": _vm.contacts,
      "search-input": _vm.search,
      "no-filter": ""
    },
    on: {
      "change": _vm.select,
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [(typeof data.item !== 'object') ? [_c('v-list-item-content', {
          domProps: {
            "textContent": _vm._s(data.item)
          }
        })] : [_c('v-list-item-avatar', [_c('img', {
          attrs: {
            "src": data.item.image
          }
        })]), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
          domProps: {
            "innerHTML": _vm._s(data.item.fullNameHighlighted)
          }
        }), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.bestContact(data.item)))])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.jump(data.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "grey"
          }
        }, [_vm._v("mdi-forwardburger")])], 1)], 1)]]
      }
    }]),
    model: {
      value: (_vm.contact),
      callback: function($$v) {
        _vm.contact = $$v
      },
      expression: "contact"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-074973f5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/AlgoliaContacts.vue
// module id = 2438
// module chunks = 1